export default "__VITE_ASSET__C1ncgI4H__"